(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var body = document.body;

  /* ---------- helpers ---------- */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency || 'ZAR', currencyDisplay: 'symbol'
      }).format(cents / 100);
    } catch (e) {
      return 'R ' + (cents / 100).toFixed(2);
    }
  }

  function openDrawer() { body.classList.add('drawer-open'); }
  function closeDrawer() { body.classList.remove('drawer-open'); }

  /* ---------- render cart ---------- */
  function renderCart(cart) {
    if (!drawer) return;
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var currency = cart.currency || drawer.getAttribute('data-currency');

    // header count
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      itemsEl.appendChild(emptyEl);
      emptyEl.hidden = false;
      footEl.hidden = true;
    } else {
      emptyEl.hidden = true;
      var html = '';
      cart.items.forEach(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
        var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1) ? '<div class="cart-line__meta">' + item.variant_title + '</div>' : '';
        html += '' +
          '<div class="cart-line" data-key="' + item.key + '">' +
            (img ? '<img src="' + img + '" alt="">' : '') +
            '<div style="flex:1">' +
              '<a href="' + item.url + '" class="cart-line__title">' + item.product_title + '</a>' +
              variant +
              '<div class="cart-line__meta">Qty ' + item.quantity + ' · ' + money(item.final_line_price, currency) + '</div>' +
              '<button type="button" class="cart-line__remove" data-remove="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div>';
      });
      itemsEl.innerHTML = html;
      footEl.hidden = false;
      drawer.querySelector('[data-cart-subtotal]').textContent = money(cart.items_subtotal_price, currency);
    }

    // free-shipping progress
    var threshold = parseInt(drawer.getAttribute('data-threshold'), 10) || 0;
    var bar = drawer.querySelector('[data-ship-bar]');
    var txt = drawer.querySelector('[data-ship-text]');
    if (threshold > 0) {
      var subtotal = cart.items_subtotal_price || 0;
      var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
      bar.style.width = pct + '%';
      if (subtotal >= threshold) {
        txt.innerHTML = '🎉 You’ve unlocked <strong>FREE delivery!</strong>';
      } else {
        txt.innerHTML = 'Spend <strong>' + money(threshold - subtotal, currency) + '</strong> more for FREE delivery.';
      }
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: Math.max(1, parseInt((form.querySelector('[name="quantity"]') || { value: 1 }).value, 10) || 1) })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () { openDrawer(); })
      .catch(function () {})
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original || 'Add to cart'; } });
  });

  /* ---------- remove line ---------- */
  document.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-qty-plus]');
    var minus = e.target.closest('[data-qty-minus]');
    if (plus || minus) {
      var stepper = e.target.closest('[data-qty-stepper]');
      var input = stepper ? stepper.querySelector('[name="quantity"]') : null;
      if (input) {
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, value + (plus ? 1 : -1));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var rem = e.target.closest('[data-remove]');
    if (rem) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: rem.getAttribute('data-remove'), quantity: 0 })
      }).then(function (r) { return r.json(); }).then(renderCart);
      return;
    }
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle) {
      e.preventDefault();
      fetchCart()
        .then(openDrawer)
        .catch(function () {
          if (cartToggle.href) window.location.href = cartToggle.href;
        });
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  if (drawer) fetchCart();

  /* ---------- recently viewed ---------- */
  var KEY = 'verdura_recently_viewed';
  // Record (set window.__recentProduct on product pages)
  if (window.__recentProduct) {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      list = list.filter(function (p) { return p.handle !== window.__recentProduct.handle; });
      list.unshift(window.__recentProduct);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 10)));
    } catch (e) {}
  }
  // Render on any page that has the section
  var rvSection = document.getElementById('recently-viewed');
  var rvTrack = document.querySelector('[data-recently-track]');
  if (rvSection && rvTrack) {
    try {
      var items = JSON.parse(localStorage.getItem(KEY) || '[]');
      var current = window.__recentProduct ? window.__recentProduct.handle : null;
      items = items.filter(function (p) { return p.handle !== current; });
      if (items.length) {
        rvTrack.innerHTML = items.map(function (p) {
          return '' +
            '<article class="product-card">' +
              '<a href="' + p.url + '" class="product-card__media">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="ph">Product</span>') + '</a>' +
              '<div class="product-card__body">' +
                (p.vendor ? '<span class="product-card__vendor">' + p.vendor + '</span>' : '') +
                '<a href="' + p.url + '" class="product-card__title">' + p.title + '</a>' +
                '<div class="product-card__price"><span class="price">' + p.price + '</span></div>' +
              '</div>' +
            '</article>';
        }).join('');
        rvSection.hidden = false;
      }
    } catch (e) {}
  }
})();

/* ---------- mobile navigation ---------- */
(function () {
  var body = document.body;
  var html = document.documentElement;
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.getElementById('MobileMenu');
  var closeEls = document.querySelectorAll('[data-mobile-menu-close]');
  var lockedScrollY = 0;
  if (!toggle || !menu) return;
  function setMenu(open) {
    if (open) {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      html.classList.add('mobile-menu-open');
      body.classList.add('mobile-menu-open');
      body.style.position = 'fixed';
      body.style.top = '-' + lockedScrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    } else {
      html.classList.remove('mobile-menu-open');
      body.classList.remove('mobile-menu-open');
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      window.scrollTo(0, lockedScrollY);
    }
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
  }
  toggle.addEventListener('click', function () { setMenu(!body.classList.contains('mobile-menu-open')); });
  document.querySelectorAll('[data-mobile-menu-toggle-bottom]').forEach(function (btn) {
    btn.addEventListener('click', function () { setMenu(true); });
  });
  closeEls.forEach(function (el) { el.addEventListener('click', function () { setMenu(false); }); });
  menu.addEventListener('click', function (e) {
    if (e.target.closest('a')) setMenu(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setMenu(false);
  });
})();

/* ---------- mobile bottom navigation visibility ---------- */
(function () {
  var header = document.querySelector('.header');
  var bottomNav = document.querySelector('.mobile-bottom-nav');
  if (!header || !bottomNav) return;

  function updateBottomNav() {
    if (!window.matchMedia('(max-width: 749px)').matches) {
      bottomNav.classList.remove('is-header-visible');
      return;
    }
    var rect = header.getBoundingClientRect();
    var headerVisible = rect.bottom > 0 && rect.top < window.innerHeight;
    bottomNav.classList.toggle('is-header-visible', headerVisible);
    bottomNav.setAttribute('aria-hidden', headerVisible ? 'true' : 'false');
  }

  updateBottomNav();
  window.addEventListener('scroll', updateBottomNav, { passive: true });
  window.addEventListener('resize', updateBottomNav);
})();

/* ---------- search results header search toggle ---------- */
(function () {
  var body = document.body;
  var form = document.querySelector('[data-header-search-form]');
  var toggles = document.querySelectorAll('[data-header-search-toggle]');
  if (!form || !toggles.length) return;

  function setSearch(open) {
    form.classList.toggle('is-open', open);
    body.classList.toggle('search-open', open);
    toggles.forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    if (open) {
      var input = form.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); input.select(); }, 60);
    }
  }

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      setSearch(!form.classList.contains('is-open'));
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setSearch(false);
  });
})();
